import React, { useEffect, useState } from "react";
import Book from '../components/Book';
import { useNavigate, useParams } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './itemConfig.module.css';
import {Image} from 'react-bootstrap';
import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import MyTooltip from '../components/Utilities/MyTooltip';
import MyPressButton, {MyGreenPressButton} from '../components/Utilities/MyPressButton';


export default function ItemConfig() {
	const navigate = useNavigate();
	
	const [reorderingEnable, setReorderingEnable] = useState();
	const [addNewLabelEnable, setAddNewLabelEnable] = useState();
	
	const [teachingNoteType, setTeachingNoteType] = useState([]);
	const [theme, setTheme] = useState([]);
	const [speakingTextType, setSpeakingTextType] = useState([]);
	const [listeningLabel, setListeningLabel] = useState([]);
	
	const [teachingNoteTypeEnable, setTeachingNoteTypeEnable] = useState(true);
	const [themeEnable, setThemeEnable] = useState(true);
	const [speakingTextTypeEnable, setSpeakingTextTypeEnable] = useState(true);
	const [listeningLabelEnable, setListeningLabelEnable] = useState(true);
	
			
	const [newLabelType, setNewLabelType] = useState("theme");
	const [newLevelSection, setNewLevelSection] = useState("DSE");
	const [newName, setNewName] = useState("");
	const [newCode, setNewCode] = useState("");
	
	const fetchData = () => {
		getData('item/getConfigLabel', navigate)
		.then(res => {
				let d = res.data;
				
				for(let i of d.theme) {
					i.id = i.id.toString();
				}
				
				setTheme(d.theme);
				
				for(let i of d.speakingTextType) {
					i.id = i.id.toString();
				}
				
				setSpeakingTextType(d.speakingTextType);
				
				for(let i of d.listeningLabel) {
					i.id = i.id.toString();
				}
				
				setListeningLabel(d.listeningLabel);
				
				for(let i of d.teachingNoteType) {
					i.id = i.id.toString();
				}
				
				setTeachingNoteType(d.teachingNoteType);
			}
		);
	}
	
	const addNewLabel = async () => {
		
		let obj = {labelType:newLabelType, levelSection:newLevelSection, name:newName, code:newCode};
		
		await postData("item/addNewLabel", obj, navigate);		
		fetchData();
	}	
	
	useEffect(() => {
		fetchData();
	}, []);
	

	return (<div>
		<div className="generalTitleHolder">
			<div>Item Config</div>			
			<MyTooltip msg={"&lt;page&gt;" +
										"itemConfig.js<br/><br/>" +
										"&lt;components&gt;<br/>" +
										" X <br/>"} /> 
			
		</div>
		<div className="generalConfigHolder">
			<div>Mode:</div>
			<MyPressButton isPressed={reorderingEnable} clickedAction={()=>{setReorderingEnable(p=>!p)}} bText="Enable Reordering"/>
			<MyPressButton isPressed={addNewLabelEnable} clickedAction={()=>{setAddNewLabelEnable(p=>!p)}} bText="Add new label"/>			
		</div>
		
		{
			(addNewLabelEnable) && (
			<div className="generalConfigHolder" >
				<div>Add New Label</div>
			
				
				<div style={{display:"flex", gap:"10px"}}>
					<div>Type</div>
					<select value={newLabelType} onChange={(e)=>{
							setNewLabelType(e.target.value);								
						}}>
						<option value="teaching-note-type">Teaching Note Type</option>
						<option value="theme">Theme</option>
						<option value="listening-label">Listening Label</option>
						<option value="speaking-text-type">Speaking Text Type</option>
					</select>
					{
						(['theme', 'listening-label'].includes(newLabelType)) && (<>
							<div>Level</div>
							<select value={newLevelSection} onChange={(e)=>{
									setNewLevelSection(e.target.value);
									
								}}>
								<option value="DSE">DSE</option>
								<option value="Pre-DSE">Pre-DSE</option>
							</select>
						</>)
					}			
					<div>Name</div>				
					<input className={"inputBox"} type="text" value={newName}
						onChange={(e)=>{
							setNewName(e.target.value);
						}}/>
					{
						(['listening-label'].includes(newLabelType)) && (<>
						<div>Code</div>
						<input className={"inputBox"} type="text" value={newCode}
							onChange={(e)=>{
								setNewCode(e.target.value);
							}}/>
						</>)
					}
				
				</div>
				<div style={{marginLeft:"20px"}}>
				<GreenButton isEnabled={true}
					clickedAction={()=>addNewLabel()} bText={"Add"} />
			
				</div>
			</div>)
			
		}
		
		<div style={{display:"flex", width:"100%", margin:"20px"}}>
		
		<GeneralLabelList 
			showReordering={reorderingEnable}
			type={'teaching-note-type'} header={'Teaching Note Type'}
			postReorderingLink={'reorderTeachingNoteType'}
			postLink={'updateTeachingNoteType'}
			data={teachingNoteType} setData={setTeachingNoteType} isEnable={teachingNoteTypeEnable} setIsEnable={setTeachingNoteTypeEnable} />
		
		<GeneralLabelList 
			showReordering={reorderingEnable}
			type={'theme'} header={'Theme'}
			postReorderingLink={'reorderTheme'}
			postLink={'updateTheme'}
			data={theme} setData={setTheme} isEnable={themeEnable} setIsEnable={setThemeEnable} />
		
		<GeneralLabelList 
			showReordering={reorderingEnable}
			type={'listening-label'} header={'Listening Label'}
			postReorderingLink={'reorderListeningLabel'}
			postLink={'updateListeningLabel'}
			data={listeningLabel} setData={setListeningLabel} isEnable={listeningLabelEnable} setIsEnable={setListeningLabelEnable} />
		
		<GeneralLabelList 
			showReordering={reorderingEnable}
			type={'theme'} header={'Speaking Text'}
			postReorderingLink={'reorderSpeakingTextType'}
			postLink={'updateSpeakingTextType'}
			data={speakingTextType} setData={setSpeakingTextType} isEnable={speakingTextTypeEnable} setIsEnable={setSpeakingTextTypeEnable} />
		
		{/*
			(<ThemeList theme={theme} setTheme={setTheme} themeEnable={themeEnable} setThemeEnable={setThemeEnable}/ >)
		}		
		{
			(<ListeningLabelList listeningLabel={listeningLabel} setListeningLabel={setListeningLabel} listeningLabelEnable={listeningLabelEnable} setListeningLabelEnable={setListeningLabelEnable}/ >)
		
		}
		{
			(<SpeakingTextTypeList speakingTextType={speakingTextType} setSpeakingTextType={setSpeakingTextType} speakingTextTypeEnable={speakingTextTypeEnable} setSpeakingTextTypeEnable={setSpeakingTextTypeEnable}/ >)
		*/}

		</div>
	</div>)
}

/*
const ThemeList = ({theme, setTheme, themeEnable, setThemeEnable}) => {
	const navigate = useNavigate();	
	
	const updateData = (indexT, id, levelSection, name) => {
		theme[indexT].isUpdate = false;
		setTheme([...theme]);
		
		let obj = {id, levelSection, name};
		
		postData("item/updateTheme", obj, navigate);		
	}	
	
	return (<div className={(themeEnable) ? s.listHolder : s.listHolder + " " + s.listHolderCover}>
		<div className={s.titleLabel}
		onClick={()=>setThemeEnable(p=>!p)}>Theme</div>
		{theme.map((t, indexT)=>(
		
			<div className={(themeEnable) ? s.titleContent : s.titleContent + " " + s.titleContentCover} key={"theme" + indexT}>
				<select value={t.levelSection} onChange={(e)=>{
						theme[indexT].levelSection = e.target.value;
						theme[indexT].isUpdate = true;
						setTheme([...theme]);
					}}>
					<option value="DSE">DSE</option>
					<option value="Pre-DSE">Pre-DSE</option>
				</select>
				<input className={"inputBox"} style={{minWidth:"100px",width:"100%"}} type="text" value={t.name}
					onChange={(e)=>{
						theme[indexT].name = e.target.value;
						theme[indexT].isUpdate = true;
						setTheme([...theme]);
					}}/>
				
				<div style={{margin:"0 5px 0 auto"}}>
					<GreenButton isEnabled={t.isUpdate} overrideStyle={{padding:"2px", borderRadius:"3px", fontSize:"12px"}} 
						clickedAction={()=>updateData(indexT, t.id, t.levelSection, t.name)} bText={"Update"} />
				</div>
			</div>
		))}
	</div>)
}

const ListeningLabelList = ({listeningLabel, setListeningLabel, listeningLabelEnable, setListeningLabelEnable}) => {
	const navigate = useNavigate();	
	
	const updateData = (indexT, id, levelSection, code, name) => {
		listeningLabel[indexT].isUpdate = false;
		setListeningLabel([...listeningLabel]);
		
		let obj = {id, levelSection, code, name};
		
		postData("item/updateListeningLabel", obj, navigate);		
	}	
	
	return (<div className={(listeningLabelEnable) ? s.listHolder : s.listHolder + " " + s.listHolderCover}>
		<div className={s.titleLabel}
		onClick={()=>setListeningLabelEnable(p=>!p)}>Listening Label</div>
		{listeningLabel.map((t, indexT)=>(<div className={(listeningLabelEnable) ? s.titleContent : s.titleContent + " " + s.titleContentCover} key={"listeningLabel" + indexT}>
			
			<select value={t.levelSection} onChange={(e)=>{
					listeningLabel[indexT].levelSection = e.target.value;
					listeningLabel[indexT].isUpdate = true;
					setListeningLabel([...listeningLabel]);
				}}>
				<option value="DSE">DSE</option>
				<option value="Pre-DSE">Pre-DSE</option>
			</select>
			
			<input className={"inputBox"} style={{minWidth:"150px",width:"100%"}} type="text" value={t.name}
				onChange={(e)=>{
					listeningLabel[indexT].name = e.target.value
					listeningLabel[indexT].isUpdate = true
					setListeningLabel([...listeningLabel]);
				}}/>
				
			<input className={"inputBox"} style={{minWidth:"50px"}} type="text" value={t.code}
				onChange={(e)=>{
					listeningLabel[indexT].code = e.target.value
					listeningLabel[indexT].isUpdate = true
					setListeningLabel([...listeningLabel]);
				}}/>
			
			
			<div style={{margin:"0 5px 0 auto"}}>
				<GreenButton isEnabled={t.isUpdate} overrideStyle={{padding:"2px", borderRadius:"3px", fontSize:"12px"}} 
					clickedAction={()=>updateData(indexT, t.id, t.levelSection, t.code, t.name)} bText={"Update"} />
			</div>
		</div>))}
	</div>)
}

const SpeakingTextTypeList = ({speakingTextType, setSpeakingTextType, speakingTextTypeEnable, setSpeakingTextTypeEnable}) => {
	const navigate = useNavigate();	
	
	const updateData = (indexT, id, name) => {
		speakingTextType[indexT].isUpdate = false;
		setSpeakingTextType([...speakingTextType]);
		
		let obj = {id, name};
		
		postData("item/updateSpeakingTextType", obj, navigate);		
	}	
	
	return (<div className={(speakingTextTypeEnable) ? s.listHolder : s.listHolder + " " + s.listHolderCover}>
		<div className={s.titleLabel}
		onClick={()=>setSpeakingTextTypeEnable(p=>!p)}>Speaking Text Type</div>
		{speakingTextType.map((t, indexT)=>(<div className={(speakingTextTypeEnable) ? s.titleContent : s.titleContent + " " + s.titleContentCover} key={"speakingTextType" + indexT}>
			
			
			<input className={"inputBox"} style={{minWidth:"100px",width:"100%"}} type="text" value={t.name}
				onChange={(e)=>{
					speakingTextType[indexT].name = e.target.value
					speakingTextType[indexT].isUpdate = true
					setSpeakingTextType([...speakingTextType]);
				}}/>
			<div style={{margin:"0 5px 0 auto"}}>
				<GreenButton isEnabled={t.isUpdate} overrideStyle={{padding:"2px", borderRadius:"3px", fontSize:"12px"}}
					clickedAction={()=>updateData(indexT, t.id, t.name)} bText={"Update"} />
			</div>
		</div>))}
	</div>)
}*/



const GeneralLabelList = ({showReordering, type, header, postReorderingLink, postLink, data, setData, isEnable, setIsEnable}) => {
	const navigate = useNavigate();	
	
	const updateData = (indexT, t) => {
		data[indexT].isUpdate = false;
		setData([...data]);
				
		postData("item/" + postLink, t, navigate);		
	}	
	
	const updateLabelOrdering = (newLabel) => {
		let objs = [];
		
		for (let i = 0; i < newLabel.length; i++) {
			objs.push({id:newLabel[i].id, ordering:i});
		}
		
		let param = {
			label:objs
		}
		postData("item/" + postReorderingLink, param, navigate); 
	}
	
	const onDragEnd = async (result) => {
    if (!result.destination) return;
    const newItems = Array.from(data);
    const [removed] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, removed);
		
		updateLabelOrdering(newItems);
		
    setData(newItems);
  };
	
	return (<div className={(isEnable) ? s.listHolder : s.listHolder + " " + s.listHolderCover}>
		<div className={s.titleLabel}
		onClick={()=>setIsEnable(p=>!p)}>{header}</div>
				<DragDropContext onDragEnd={onDragEnd}>
					<Droppable droppableId={type}>
						{(provided) => (
							<div {...provided.droppableProps} ref={provided.innerRef} >
								
								
		{data.map((t, indexT)=>(
		
									<Draggable key={t.id} draggableId={t.id} index={indexT} isDragDisabled={!showReordering}>
										{(provided) => (
											<div
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												ref={provided.innerRef}>
		
		
		
		
			<div className={(isEnable) ? s.titleContent : s.titleContent + " " + s.titleContentCover} key={type + indexT}>
				
				
				
				{
					(['theme', 'listening-label'].includes(type)) && (<select value={t.levelSection} disabled={showReordering} onChange={(e)=>{
						data[indexT].levelSection = e.target.value;
						data[indexT].isUpdate = true;
						setData([...data]);
					}}>
						<option value="DSE">DSE</option>
						<option value="Pre-DSE">Pre-DSE</option>
					</select>)
				}
				
				<input className={"inputBox"} style={{minWidth:"100px",width:"100%"}} type="text" value={t.name} disabled={showReordering}
					onChange={(e)=>{
						data[indexT].name = e.target.value
						data[indexT].isUpdate = true
						setData([...data]);
					}}/>
					
				{
					(['listening-label'].includes(type)) && (<input className={"inputBox"} style={{minWidth:"50px"}} type="text" value={t.code} disabled={showReordering}
						onChange={(e)=>{
							data[indexT].code = e.target.value
							data[indexT].isUpdate = true
							setData([...data]);
						}}/>)
				}
				
				{
					(!showReordering) && (<div style={{margin:"0 5px 0 auto"}}>
						<GreenButton isEnabled={t.isUpdate} overrideStyle={{padding:"2px", borderRadius:"3px", fontSize:"12px"}}
							clickedAction={()=>updateData(indexT, t)} bText={"Update"} />
					</div>)
				}
				{
					(showReordering) && (<div style={{width:"100px", borderRadius:"5px", border:"2px solid #5d5c5c", color:"#5d5c5c"}}>drag</div>)
				}
			</div>
		
											</div>
										)}
									</Draggable>
		
		))}
		
		
								{provided.placeholder}
							</div>
						)}
					</Droppable>
				</DragDropContext>
		
		
		
	</div>)
}